var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoopingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 5.83333C17.4227 5.58385 17.2165 5.37594 16.9682 5.22989C16.7199 5.08384 16.438 5.00464 16.15 5H5.48335L5.00002 3.11667C4.95119 2.93487 4.84224 2.77495 4.69092 2.66298C4.5396 2.551 4.35482 2.49356 4.16669 2.5H2.50002C2.27901 2.5 2.06704 2.5878 1.91076 2.74408C1.75448 2.90036 1.66669 3.11232 1.66669 3.33333C1.66669 3.55435 1.75448 3.76631 1.91076 3.92259C2.06704 4.07887 2.27901 4.16667 2.50002 4.16667H3.53335L5.83335 12.7167C5.88219 12.8985 5.99114 13.0584 6.14246 13.1704C6.29378 13.2823 6.47855 13.3398 6.66669 13.3333H14.1667C14.3206 13.3329 14.4713 13.2898 14.6022 13.2089C14.7332 13.128 14.8391 13.0124 14.9084 12.875L17.6417 7.40833C17.7602 7.16001 17.8153 6.88623 17.8022 6.6114C17.7891 6.33658 17.7082 6.06927 17.5667 5.83333Z",
    fill: "#00ADEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.5C6.94036 17.5 7.5 16.9404 7.5 16.25C7.5 15.5596 6.94036 15 6.25 15C5.55964 15 5 15.5596 5 16.25C5 16.9404 5.55964 17.5 6.25 17.5Z",
    fill: "#00ADEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 17.5C15.2737 17.5 15.8333 16.9404 15.8333 16.25C15.8333 15.5596 15.2737 15 14.5833 15C13.893 15 13.3333 15.5596 13.3333 16.25C13.3333 16.9404 13.893 17.5 14.5833 17.5Z",
    fill: "#00ADEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoopingCart);
export default __webpack_public_path__ + "static/media/shooping-cart.7677fad7c1efc4ddd1b27eff66522869.svg";
export { ForwardRef as ReactComponent };